import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cross from "../../assets/images/icon/cross.svg";
import { faImages, faLock, faUpload } from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { bytesToMB } from "helpers/common";
import { uploadUserDocuments } from "helpers/backend_helper";
import { at, isEmpty } from "lodash";
import edit_icon from "../../assets/images/icon/edit.svg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import { checkPermissionStatus } from "helpers/utils";

const PreviousExperience = props => {
  const { t } = useTranslation();
  const [degreeList, setDegreeList] = useState([
    {
      id: 1,
      companyName: "",
      jobTitle: "",
      joiningDate: "",
      relievingDate: "",
      location: "",
      description: "",
    },
  ]);
  const [attachments, setAttachments] = useState(new Map().set(1, ""));
  const [errors, setErrors] = useState([{ id: 1 }]);
  const [loading, setLoading] = useState(false);
  const [viewType, setViewType] = useState("view");
  const candidateDetails = props?.data?.length
    ? props?.data?.map(el => {
        return JSON.parse(el?.fields);
      })
    : [];

  const imageTypeAllowed = [
    "application/doc",
    "application/docx",
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/msword",
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const handleFileUpload = async (e, index) => {
    let allErrors = JSON.parse(JSON.stringify(errors));

    let objIndex = allErrors?.findIndex(el => el?.id === index);

    if (objIndex !== -1) {
      allErrors[objIndex].attachmentFile = "";
      setErrors(allErrors);
    }

    if (e?.target?.files?.length > 0) {
      let maxSize = 25;
      let isError = false;

      if (e?.target?.files?.length > 1) {
        toast.error("Cannot Select More than one Attachment");
        return;
      }

      for (let i = 0; i < e.target.files.length; i++) {
        let file = e.target.files[i];

        if (!imageTypeAllowed.includes(file.type)) {
          isError = true;
        }

        let megabytes = bytesToMB(file.size);
        if (megabytes > maxSize) {
          toast.error("Please select attachment below 25MB");
          return;
        }

        attachments.set(index, file);
      }

      if (isError) {
        toast.error("Invalid file type");
        return;
      }
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();

    if (degreeList?.length === 0) {
      toast.error(t(`Previous Experience.Please Add atleast One Entry`));
      return;
    }
    setLoading(true);
  let isError = false;

let error = degreeList?.map((el, index) => {
  let err = { id: el.id };

  if (isEmpty(el?.companyName)) {
    err = {
      ...err,
      companyName: t(`Previous Experience.This Field is Required`),
    };
    isError = true;
  }

  if (isEmpty(el?.jobTitle)) {
    err = {
      ...err,
      jobTitle: t(`Previous Experience.This Field is Required`),
    };
    isError = true;
  }

  if (!el?.joiningDate) {
    err = {
      ...err,
      joiningDate: t(`Previous Experience.This Field is Required`),
    };
    isError = true;
  }

  if (!el?.relievingDate) {
    err = {
      ...err,
      relievingDate: t(`Previous Experience.This Field is Required`),
    };
    isError = true;
  }

  if (isEmpty(el?.location)) {
    err = {
      ...err,
      location: t(`Previous Experience.This Field is Required`),
    };
    isError = true;
  }

  if (isEmpty(el?.description)) {
    err = {
      ...err,
      description: t(`Previous Experience.This Field is Required`),
    };
    isError = true;
  }

  if (!attachments.get(el.id)) {
    err = {
      ...err,
      attachments: t(`Previous Experience.This Field is Required`),
    };
    isError = true;
  }

  if (
    new Date(el?.joiningDate).getTime() >
    new Date(el?.relievingDate).getTime()
  ) {
    err = {
      ...err,
      joiningDate: t(
        `Previous Experience.Start Date Cannot be greater then End Date`
      ),
    };
    isError = true;
  }

  return err; // ✅ required
});

    if (isError) {
      toast.error(t(`Previous Experience.Please Enter Valid Details`));
      setLoading(false);
      setErrors(error);
      return false;
    }

    let userID = props?.user_id;
    let newAttachments = {};
    for (let [key, value] of attachments) {
      let keyName = `attachment-${key}`;
      newAttachments[keyName] = value;
    }

    let payload = {
      degreeList: JSON.stringify(degreeList),
      type: "previousExpDetails",
      new_status: "Previxous Experience Details",
      ...newAttachments,
      appl_id: props?.appl_id,
    };

    await uploadUserDocuments(payload, userID)
      .then(res => {
        toast.success(
          t(
            `Previous Experience.Previous Experience Details Updated Successfully`
          )
        );
        props?.onSubmit();
        setViewType("view");
      })
      .then(err => {
        if (err?.response?.message) {
          toast.error(JSON.stringify(err?.response?.message));
        }
      });
  };

  const getUniqueId = () => {
    let allIds = degreeList?.map(el => el?.id);
    let randomId = getRandomInteger(20);
    while (allIds?.includes(randomId)) {
      randomId = getRandomInteger(20);
    }
    return randomId;
  };

  const getRandomInteger = maxSize => {
    return Math.floor(Math.random() * maxSize);
  };

  const handleRemove = id => {
    let myDegrees = JSON.parse(JSON.stringify(degreeList));
    myDegrees = myDegrees?.filter(el => el.id !== id);
    setDegreeList(myDegrees);
    attachments.delete(id);
  };

  const handleAddMore = e => {
    e.preventDefault();
    if (degreeList?.length > 10) {
      toast.error(t(`Previous Experience.Max 10 Experiences are allowed`));
      return false;
    }
    let myDegrees = JSON.parse(JSON.stringify(degreeList));
    let uniqueId = getUniqueId();
    myDegrees.push({
      id: uniqueId,
      companyName: "",
      jobTitle: "",
      joiningDate: "",
      relievingDate: "",
      location: "",
      description: "",
    });
    let allErrors = JSON.parse(JSON.stringify(errors));
    allErrors.push({ id: uniqueId });
    setDegreeList(myDegrees);
    setErrors(allErrors);
    attachments.set(myDegrees?.length - 1, "");
  };

const handleChange = (e, index, type) => {
  let keyElement = type || e?.target?.name;

  if (!keyElement) return;

  let keyValue;

  if (type === "joiningDate" || type === "relievingDate") {
    keyValue = e || null; // ✅ handle cleared date
  } else {
    if (!e || !e.target) return; // ✅ prevent crash
    keyValue = e.target.value;
  }

  let allDegrees = JSON.parse(JSON.stringify(degreeList));
  allDegrees[index][keyElement] = keyValue;
  setDegreeList(allDegrees);
};

  const handleAttachmentOpen = file => {
    if (file) {
      if (typeof file === "string") {
        window.open(file);
      } else {
        window.open(URL.createObjectURL(file));
      }
    }
  };

  const handleReset = () => {
    if (props?.data?.length) {
      let myData = props?.data || [];
      attachments.clear();
      let myDegrees = myData?.map(el => {
        let fields = JSON.parse(el?.fields);
        attachments.set(fields?.id, el?.files);
        return fields;
      });
      setDegreeList(myDegrees);
    }
  };

  useEffect(() => {
    if (props?.data?.length) {
      let myData = props?.data || [];
      attachments.clear();
      let myDegrees = myData?.map(el => {
        let fields = JSON.parse(el?.fields);
        attachments.set(fields?.id, el?.files);
        return fields;
      });
      setDegreeList(myDegrees);
    }
  }, [props?.data]);

  const [isExpanded, setIsExpanded] = useState(false);
  const toggleReadMore = () => setIsExpanded(!isExpanded);

  return (
    <>
      {/* <div className="modal-header d-flex justify-content-between align-items-center">
        <h4 className="m-0">Upload Previous Experience Details</h4>
        <div className="filter-content cross" onClick={() => props?.close()}>
          <img src={cross} alt="" />
        </div>
      </div> */}
      <div className="d-flex justify-content-between align-items-center modal-subheading mb-2 pt-2">
        <h4 className="d-flex gap-2 align-items-center">
          {t(`Previous Experience.Previous Experiences`)}
        </h4>
        <div>
          {viewType === "view" ? (
            <Link
              className="text-success blue-icon blue-color4"
              to={`#`}
              onClick={() => setViewType("edit")}
              title={t(`Previous Experience.Edit Details`)}
            >
              <img src={edit_icon} alt="delete_icon" />
            </Link>
          ) : (
            <button
              color="danger"
              onClick={() => {
                setViewType("view");
                handleReset();
              }}
              className="btn btn-secondary"
            >
              {t(`Previous Experience.Cancel`)}
            </button>
          )}
        </div>
      </div>
      {viewType === "edit" && (
        <div className="filters-cards-cross">
          <form
            onSubmit={handleSubmit}
            id="schedulef2f"
            style={{ display: "block" }}
            className="filters-cards-previous"
          >
            <div className="form-group">
              {degreeList &&
                degreeList?.map((el, index) => {
                  let objIndex = errors?.findIndex(item => item.id === el.id);
                  let errorValues = errors[objIndex];
                  return (
                    <div className="row" key={index}>
                      <div className=" voter-upload">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <label className="btn btn-primary upload-button">
                              <FontAwesomeIcon icon={faUpload} />
                              <span className="mx-2">
                                {t(
                                  `Previous Experience.Upload Experience Document`
                                )}
                              </span>
                              <input
                                type="file"
                                multiple
                                accept={imageTypeAllowed.join(",")}
                                onChange={e => {
                                  handleFileUpload(e, el.id);
                                }}
                                style={{ display: "none" }}
                              />
                            </label>
                            {attachments.get(el?.id) && (
                              <FontAwesomeIcon
                                className="mx-4"
                                icon={faImages}
                                style={{ cursor: "pointer" }}
                                width={"25px"}
                                height={"25px"}
                                onClick={() =>
                                  handleAttachmentOpen(attachments.get(el?.id))
                                }
                              />
                            )}
                          </div>
                          <button
                            className="btn btn-primary text-right btn-remove-padding"
                            onClick={e => {
                              e.preventDefault();
                              handleRemove(el?.id);
                            }}
                          >
                            -
                          </button>
                        </div>
                        <p className="pb-2">
                          {t(`Previous Experience.Supported file types are`)}
                        </p>
                        {errorValues?.attachments && (
                          <p className="text-danger">
                            {errorValues?.attachments}
                          </p>
                        )}
                      </div>

                      <div className="row form-upload-card">
                        <div className="col-lg-4 col-md-6  mb-4">
                          <span className="font-size-14">
                            {t(`Previous Experience.Company Name`)}
                          </span>
                          <div className="mt-2">
                            <input
                              for="companyName"
                              name="companyName"
                              type="text"
                              className="form-control"
                              placeholder={t(
                                `Previous Experience.Enter Company Name`
                              )}
                              value={el?.companyName}
                              onChange={e => handleChange(e, index)}
                              title={`${t(`Previous Experience.Company Name`)}`}
                            />
                          </div>
                          {errorValues?.companyName && (
                            <p className="text-danger">
                              {errorValues?.companyName}
                            </p>
                          )}
                        </div>
                        <div className="col-lg-4 col-md-6  mb-4">
                          <span className="font-size-14">
                            {t(`Previous Experience.Job Title`)}
                          </span>
                          <div className="mt-2">
                            <input
                              for="jobTitle"
                              name="jobTitle"
                              type="text"
                              className="form-control"
                              placeholder={t(
                                `Previous Experience.Enter Job Title`
                              )}
                              value={el?.jobTitle}
                              onChange={e => handleChange(e, index)}
                              title={`${t(`Previous Experience.Job Title`)}`}
                            />
                          </div>
                          {errorValues?.jobTitle && (
                            <p className="text-danger">
                              {errorValues?.jobTitle}
                            </p>
                          )}
                        </div>

                        <div className="col-lg-4 col-md-6  mb-4">
                          <span className="font-size-14">
                            {t(`Previous Experience.Date of Joining`)}
                          </span>
                          <div className="mt-2">
                            <DatePicker
                              selected={
                                el?.joiningDate ? new Date(el?.joiningDate) : null
                              }
                              showYearDropdown
                              for="joiningDate"
                              name="joiningDate"
                              onChange={date => {
                                handleChange(date, index, "joiningDate");
                              }}
                              maxDate={new Date()}
                              className="form-control"
                              dateFormat="dd-MM-yyyy"
                              placeholderText={t(
                                `Previous Experience.Select Date`
                              )}
                              title={`${t(
                                `Previous Experience.Date of Joining`
                              )}`}
                            />
                          </div>
                          {errorValues?.joiningDate && (
                            <p className="text-danger">
                              {errorValues?.joiningDate}
                            </p>
                          )}
                        </div>

                        <div className="col-lg-4 col-md-6  mb-4">
                          <span className="font-size-14">
                            {t(`Previous Experience.Date of Relieving`)}
                          </span>
                          <div className="mt-2">
                            <DatePicker
                              selected={
                                el?.relievingDate
                                  ? new Date(el?.relievingDate)
                                  : null
                              }
                              showYearDropdown
                              name="relievingDate"
                              for="relievingDate"
                              onChange={date => {
                                handleChange(date, index, "relievingDate");
                              }}
                              maxDate={new Date()}
                              className="form-control"
                              dateFormat="dd-MM-yyyy"
                              placeholderText={t(
                                `Previous Experience.Select Date`
                              )}
                              title={`${t(
                                `Previous Experience.Date of Relieving`
                              )}`}
                            />
                          </div>
                          {errorValues?.relievingDate && (
                            <p className="text-danger">
                              {errorValues?.relievingDate}
                            </p>
                          )}
                        </div>

                        <div className="col-lg-4 col-md-6  mb-4">
                          <span className="font-size-14">
                            {t(`Previous Experience.Location`)}
                          </span>
                          <div className="mt-2">
                            <input
                              for="location"
                              name="location"
                              type="text"
                              className="form-control"
                              placeholder={t(
                                `Previous Experience.Enter Location`
                              )}
                              value={el?.location}
                              onChange={e => handleChange(e, index)}
                              title={`${t(`Previous Experience.Location`)}`}
                            />
                          </div>
                          {errorValues?.location && (
                            <p className="text-danger">
                              {errorValues?.location}
                            </p>
                          )}
                        </div>

                        <div className="col-lg-12 mb-3">
                          <span className="font-size-14">
                            {t(`Previous Experience.Description`)}
                          </span>
                          <div className="mt-2">
                            <textarea
                              for="description"
                              name="description"
                              type="text"
                              rows="4"
                              cols="50"
                              className="form-control textarea"
                              placeholder={t(`Previous Experience.Description`)}
                              value={el?.description}
                              onChange={e => handleChange(e, index)}
                              title={`${t(`Previous Experience.Description`)}`}
                            />
                          </div>
                          {errorValues?.description && (
                            <p className="text-danger">
                              {errorValues?.description}
                            </p>
                          )}
                        </div>
                        <hr className="hr-row" />
                      </div>
                    </div>
                  );
                })}

              <button
                className="btn btn-primary btn-add-padding previous-add mb-3"
                onClick={e => handleAddMore(e)}
              >
                + {t(`Previous Experience.Add More`)}
              </button>

              <div className="serach-btn">
                <button className="btn btn-primary search">
                  {t(`Previous Experience.Save`)}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
      {viewType === "view" && (
        <>
          {candidateDetails?.length > 0 &&
            candidateDetails?.map(el => {
              return (
                <>
                  <div className="personal-card">
                    <div className="document-detail-badge">
                      <div>
                        <label className="data-label">
                          {t(`Previous Experience.Company Name`)}
                        </label>
                        <p className="text-wrap text-truncate-2 ">
                          <span className="">{el?.companyName}</span>
                        </p>
                      </div>
                    </div>
                    <div className="document-detail-badge">
                      <div>
                        <label className="data-label">
                          {t(`Previous Experience.Job Title`)}
                        </label>
                        <p className="text-wrap text-truncate-2 ">
                          <span className="">{el?.jobTitle}</span>
                        </p>
                      </div>
                    </div>
                    <div className="document-detail-badge">
                      <div>
                        <label className="data-label">
                          {t(`Previous Experience.Date of Joining`)}
                        </label>
                        <p className="text-wrap text-truncate-2 ">
                          <span className="">
                            {(() => {
                              const d = new Date(el?.joiningDate);
                              return el?.joiningDate && !isNaN(d)
                                ? d.toDateString()
                                : "-";
                            })()}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="document-detail-badge">
                      <div>
                        <label className="data-label">
                          {t(`Previous Experience.Date of Relieving`)}
                        </label>
                        <p className="text-wrap text-truncate-2 ">
                          <span className="">
                            {(() => {
                              const d = new Date(el?.relievingDate);
                              return el?.relievingDate && !isNaN(d)
                                ? d.toDateString()
                                : "-";
                            })()}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="document-detail-badge">
                      <div>
                        <label className="data-label">
                          {t(`Previous Experience.Location`)}
                        </label>
                        <p className="text-wrap text-truncate-2 ">
                          <span className="">{el?.location}</span>
                        </p>
                      </div>
                    </div>

                    <div className="document-detail-badge">
                      <div>
                        <label className="data-label">
                          {t(`Previous Experience.Document`)}
                          {attachments.get(el?.id) &&
                          !checkPermissionStatus(
                            "personal-id-info",
                            "view_unmasked"
                          ) ? (
                            <>
                              {" "}
                              <FontAwesomeIcon
                                icon={faLock}
                                title="You are not authorized to view this document"
                              />
                            </>
                          ) : (
                            <></>
                          )}
                        </label>
                        <p className="text-wrap text-truncate-2 ">
                          {attachments.get(el?.id) && (
                            <FontAwesomeIcon
                              className="mx-4"
                              icon={faImages}
                              style={{ cursor: "pointer" }}
                              width={"25px"}
                              height={"25px"}
                              onClick={() =>
                                !checkPermissionStatus(
                                  "personal-id-info",
                                  "view_unmasked"
                                )
                                  ? null
                                  : handleAttachmentOpen(
                                      attachments.get(el?.id)
                                    )
                              }
                            />
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="personal-card document-cards">
                    <div className="document-detail-badge">
                      <div>
                        <label className="data-label">
                          {t(`Previous Experience.Description`)}
                        </label>
                        <p className="text-wrap">
                          {isExpanded
                            ? el?.description
                            : el?.description.slice(0, 150) + "..."}
                          <button
                            onClick={toggleReadMore}
                            className="readmorbtn"
                          >
                            {isExpanded
                              ? t(`Previous Experience.Read Less`)
                              : t(`Previous Experience.Read More`)}
                          </button>
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="line-braker"></div>
                </>
              );
            })}
          {candidateDetails?.length === 0 && (
            <p className="pdf-details">
              {t(`Previous Experience.No Details Available`)}
            </p>
          )}
        </>
      )}
    </>
  );
};

export default PreviousExperience;
